export const PATHS = {
  ROOT: "/",
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
  BLOCKED_USER: "/blockeduser",
  AUTH_CALLBACK_AZURE_AD: "/api/auth/callback/azure-ad",

  HOME: "/home",

  // Documentation
  DOC_SHIPPING: "/documentation/shipping",
  DOC_SHIPPING_V1: "/documentation/shipping/v1",
  DOC_SHIPPING_V2: "/documentation/shipping/v2",
  DOC_ANALYSIS: "/documentation/analysis",
  
  DOC_ANALYSIS_SOLICITACAO: "/documentation/analysis/solicitacao/:idSolicitacao",
  DOC_EXTRACT: "/documentation/extract",
  EXTRACT_SINDICATO: "/documentation/extract/sindicato",
  EXTRACT_SINDICATO_DETALHE:
    "/documentation/extract/sindicato/:solicitacaoAvaliacaoId",

  // Flows / detalhes
  ANALISE_DETALHE: "/analise/:idResposta/:idSindicato",
  EXTRACT_DETALHE: "/extract/:idResposta/:idSindicato",
  EXTRACT_MODAL: "/extractModal/:idResposta/:idSindicato",

  // Financeiro
  EXTRACT_ENVIO_COMP: "/extract/EnvioCompDesp",
  EXTRACT_PAYMENT_TABLE: "/extract/PaymentTable",
  EXTRACT_CONF_COMP: "/extract/ConferenciaCompDespesas/:idSindicato",
  COMPROVANTES_SINDICATO: "/extract/comprovantes/sindicato",

  // Payments
  PAYMENT_PAGAMENTO: "/payment/pagamento/:idSolicitacao",
  PAYMENT_LISTA: "/payment/payment",
  PAYMENT_ROOT: "/payment",

  // BI
  BI_REPORT_VIEW: "/bi/:ano",

  // Settings
  SETTINGS_PERMISSION: "/settings/permission/permission",

  // Users
  MANAGE_USERS: "/manage-users",
  MANAGE_USERS_EDIT: "/manage-users/edit/:userId",
  MANAGE_USERS_ADD: "/manage-users/add",
};
